module.exports = __webpack_public_path__ + "static/kiosk_mobile-8ac59fb64d855c5bd14e3ccad8650b31.jpg";